<script setup>
import RHDigitalListPage from '@/components/rhdigital/list/RHDigitalListPage.vue'
import { RHDigitalDepartmentEntity } from '@/entities/RHDigitalDepartmentEntity.js'
import { getRHDigitalDepartments } from '@/services/api/rhdigital.js'

const entity = new RHDigitalDepartmentEntity()
</script>

<template>
    <RHDigitalListPage :entity="entity" :fetcher="getRHDigitalDepartments" />
</template>
